export default __webpack_public_path__ + "CircularCustCapNum-Bold.f6f07be77655d48bcbb8847a57cd8cca.woff2";